import HomepageSlider from './HomepageSlider'

export default HomepageSlider
